import { byStartTime as byStartsAt } from '@mixwire/contracts';

import type { PublicChannel, QueuedTrack } from '@mixwire/contracts';

export type UpNextItem = QueuedTrack & {
  readonly colour: string;
  readonly channelId: number;
  /** Where the track sits in its own channel's queue, which is the tiebreak below. */
  readonly position: number;
};

// `startsAt` is an absolute instant, so samples from different channels/moments compare directly
// — sorting a per-channel countdown instead made near-simultaneous tracks swap on every poll.
// A paused channel sorts to the end (no start time); channel/position break exact ties.
const byStartTime = (a: UpNextItem, b: UpNextItem): number => {
  const byStart = byStartsAt(a, b);
  if (byStart !== 0) {
    return byStart;
  }
  return a.channelId === b.channelId ? a.position - b.position : a.channelId - b.channelId;
};

/** Every channel's queue, merged into one play-order strip — the frame colour is whose track it is. */
export const upNextInPlayOrder = (channels: readonly PublicChannel[]): readonly UpNextItem[] =>
  channels
    .flatMap((slot) =>
      slot.next.map((track, position) => ({
        ...track,
        colour: slot.colour,
        channelId: slot.id,
        position,
      })),
    )
    .toSorted(byStartTime);
